import api from './api';

const getTenantUsage = () => {
    return api.get('/chat/admin/usage');
};

const usageService = {
    getTenantUsage,
};

export default usageService;























